import { AppointmentConfigs } from "@elixir/types";
import { Select } from "antd";
import { useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { PopupWrapper, TooltipComponent } from "ui";
import { useMyAccessProfileV2 } from "../apis/tryst/get-my-access-profile";
import { GearRegularIcon } from "@elixir/icons";

const options = ["1", "2", "3", "4", "5", "Any"].map((i) => ({
  value: i,
  label: i,
}));

const SlotOverbookingLimitComponent: React.FC<{
  currentConfigValues?: AppointmentConfigs["apt_config"];
  setIsConfigChanged: (value: React.SetStateAction<boolean>) => void;
  setCurrentConfigValues: React.Dispatch<
    React.SetStateAction<AppointmentConfigs["apt_config"] | undefined>
  >;
  onSave: () => Promise<void>;
  isDisabled: boolean;
  isLoading: boolean;
}> = ({
  currentConfigValues,
  setIsConfigChanged,
  setCurrentConfigValues,
  onSave,
  isDisabled,
  isLoading,
}) => {
  const [showModal, setShowModal] = useState(false);
  const { data: myAccessProfile } = useMyAccessProfileV2();
  const doctorsList = myAccessProfile?.doctors || [];

  const toggleShowModal = () => {
    setShowModal(!showModal);
  };

  return (
    <Fragment>
      <TooltipComponent
        placement="top"
        title="Configure for individual doctors"
      >
        <button onClick={toggleShowModal} className="dr-relative dr-top-1">
          <GearRegularIcon className="dr-w-24 dr-h-24 dr-p-4 dr-text-darwin-touch-neutral-1000" />
        </button>
      </TooltipComponent>
      <PopupWrapper
        style={{ minHeight: "30vh", maxHeight: "75vh", overflowY: "scroll" }}
        title="Slot Booking Limit"
        open={showModal}
        onClose={toggleShowModal}
        onOk={async () => {
          await onSave();
          toggleShowModal();
        }}
        cancelText="Cancel"
        okText="Save Changes"
        width={500}
        isOkButtonDisabled={isDisabled}
        isSubmitting={isLoading}
      >
        <div className="dr-p-16 dr-flex dr-flex-col dr-gap-15 dr-max-h-3/4vh dr-overflow-auto">
          {doctorsList.map((doctor, index) => {
            const limits = currentConfigValues?.slot_overbooking_limit_per_day;
            return (
              <div className="dr-flex dr-items-center dr-justify-between">
                <div>
                  {index + 1}. {doctor.name}
                </div>
                <Select
                  value={limits?.[doctor.oid]}
                  placeholder="Any"
                  onChange={(value) => {
                    setIsConfigChanged(true);
                    setCurrentConfigValues((prev: any) => {
                      return {
                        ...(prev || {}),
                        slot_overbooking_limit_per_day: {
                          ...(prev?.slot_overbooking_limit_per_day || {}),
                          [doctor.oid]: value,
                        },
                      };
                    });
                  }}
                  options={options}
                  style={{
                    width: "70px",
                  }}
                />
              </div>
            );
          })}
        </div>
      </PopupWrapper>
    </Fragment>
  );
};

export default SlotOverbookingLimitComponent;
